import { Chip } from '@sortlist-frontend/design-system';
import { DeepNonNullable } from '@sortlist-frontend/utils';

import { AiReviewSummaryType } from './types';

export interface AiReviewContentProps {
  summary: DeepNonNullable<AiReviewSummaryType, 2>;
}

export const AiReviewContent = (props: AiReviewContentProps) => {
  const { keyPoints, themes } = props.summary;

  return (
    <div data-testid="review-summary-content" className="flex flex-col gap-6">
      <ul data-testid="review-summary-keypoints" className="flex flex-wrap gap-2">
        {keyPoints.map((keyPoint) => (
          <li key={keyPoint}>
            <Chip size="xs" variant="flat" color="secondary">
              {keyPoint}
            </Chip>
          </li>
        ))}
      </ul>
      <div data-testid="review-summary-sections" className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {themes.map((theme) => (
          <div key={theme.title} className="flex flex-col gap-1 text-sm">
            <p className="font-medium text-secondary-900">{theme.title}</p>
            <p className="text-secondary-500">{theme.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
